import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { IDoiTuongTuyenSinhActionTypes } from "../../action-types/crm-category/IDmDoiTuongTuyenSinhActionTypes";
import { IDmDoiTuongTuyenSinhReducer } from "../../page-state-model/crm-category/IDmDoiTuongTuyenSinhReducer";

const iniState: IDmDoiTuongTuyenSinhReducer = {
    status: ePageBaseStatus.is_not_initialization,
    doiTuongTuyenSinhs: []
}

export const doiTuongTuyenSinhReducer = (state: IDmDoiTuongTuyenSinhReducer = iniState, action: IDoiTuongTuyenSinhActionTypes): IDmDoiTuongTuyenSinhReducer => {
    switch (action.type) {
        case "DOI_TUONG_TUYEN_SINH_LOAD_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "DOI_TUONG_TUYEN_SINH_LOAD_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                doiTuongTuyenSinhs: action.payload
            }
        case "DOI_TUONG_TUYEN_SINH_LOAD_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                doiTuongTuyenSinhs: []
            }
        case "DOI_TUONG_TUYEN_SINH_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                editingData: action.payload
            }
        case "DOI_TUONG_TUYEN_SINH_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            }
        case "DOI_TUONG_TUYEN_SINH_SAVE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_saving
            }
        case "DOI_TUONG_TUYEN_SINH_SAVE_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
                isShowEditModal: false
            }
        case "DOI_TUONG_TUYEN_SINH_SAVE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        case "DOI_TUONG_TUYEN_SINH_DELETE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_deleting
            }
        case "DOI_TUONG_TUYEN_SINH_DELETE_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
            }
        case "DOI_TUONG_TUYEN_SINH_DELETE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        default:
            return state;
    }
}
